import React, {useContext} from "react";
import {Space, Table} from "antd";
import {TEVItemField} from "../data-rendering";
import {resolveItemFields} from "./field-descriptions";
import {PolymorphicItem} from "../../tevapi/interfaces";
import {CompareSelect} from "./compare-control";
import {ComparingItemContext} from "../../contexts/items";
import {HelpButton} from "../help/item-data-docs";
import {ComparableHelp} from "../help/comparing-help";

export const ItemTable: React.FC<{item: PolymorphicItem}> = ({item}) => {
  const compareContext = useContext(ComparingItemContext);
  const comparison = compareContext?.comparison;
  const fields = resolveItemFields(item);

  const dataSource = fields.map(
    (field, i) => ({
      title: field.title,
      key: `field-${i}`,
      itemValue: (
        <TEVItemField
          key={`field-${i}-reference`}
          value={item[field.field]}
          row={field}
        />
      ),
      compareValue: comparison ? (
        <TEVItemField
          key={`field-${i}-compare`}
          value={comparison[field.field]}
          row={field}
        />
      ) : null,
    })
  )

  const columns = [
    {
      title: "Field",
      dataIndex: "title",
      key: "field",
      render: (text: string) => <b>{text}</b>,
    },
    {
      title: "Value",
      dataIndex: "itemValue",
      key: "value",
    },
    {
      title: (
        <Space>
          <CompareSelect referenceItem={item} />
          <HelpButton
            title="Compare Select Help"
            width={700}
          >
            <ComparableHelp />
          </HelpButton>
        </Space>
      ),
      dataIndex: "compareValue",
      key: "compareValue",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      bordered
      size="small"
      pagination={false}
    />
  );
};
